import React, { useEffect, useRef, useState } from 'react';

import defaultValues from '@/constant/defaultValues';
import { lowerCase } from 'lodash';
import { Link } from 'react-router-dom';
import { buildPath } from '@/utils/common';
import { publicRoutePaths } from '@/routes/public.routes.config';
import unFav from "@/assets/images/png/no_favorite.png"
import fav from "@/assets/images/png/favorited.png"
import { useAuth } from '@/AuthProvider';
import placeholder from "@/assets/images/png/no_product.png";

function ProductCard({ data, handleQuoteClick, showContact = false, showDesc = true, showPrice = true , handlefavoriteClick, favKey = 0}) {

  const { IMAGE_PATH } = defaultValues;
  const { user, isPreKYCUser, isEndUser, memberCompanyID } = useAuth();
  const [isFav, setIsFav] = useState(null);

  /* const favClicked = (data) => {
    setIsFav((prev) => !prev);
    handlefavoriteClick(data);
  } */

  // useEffect(() => {
  //   if(data) {
  //     setIsFav(data.isFavorite);
  //   }
  // },[data]);

  useEffect(() => {
    const favClicked = (e) => {
      if (e.target.closest(`#${favKey}`)) {
        setIsFav((prev) => (prev == null ? !data.isFavorite : !prev));
        
        handlefavoriteClick(data);
      }
    };

    document.addEventListener("click", favClicked);
    return () => document.removeEventListener("click", favClicked);
  }, [data.id, favKey, isFav]);
  
  return (
    <div className='market-place-card mp-product-card' key={`product-card-${data.id+Date.now()}`}>
      <div className='inner-pad'>
        <Link to={buildPath(publicRoutePaths.PRODUCT_CATALOGUE, {
          slug: data.product_slug
        })} href={buildPath(publicRoutePaths.PRODUCT_CATALOGUE, {
          slug: data.product_slug
        })} target="_blank">
         {
              data && data?.product_thumb_media && data?.product_thumb_media?.[0]?.photo_detail ? (
                <div className='img-wrape'>
                  <img
                    src={IMAGE_PATH.BASE_URL + data.product_thumb_media[0].photo_detail}
                    alt={''}
                  />
                </div>
              ) : (
                <div className='img-wrape'>
                  <img src={placeholder} alt='' className='default-img' />
                </div>
              )
            }

          <h3 title={data && data.product_name}>{data && data.product_name}</h3>
          {
            showDesc && <p
              dangerouslySetInnerHTML={{
                __html: data ? data.product_description : "",
              }}
            />
          }
          {
            showPrice && ((data && data.price_type === "fixed") ? <span className='price-qty'>{`$${data.price} Per ${data.price_unit}`}</span> : <span className='price-qty'>Price Upon Request</span>)
          }

          <div className='flag-section'>
            {/* <i className='flag'></i> */}
            {data && data.company && data.company.country && <img src={require(`@/assets/images/svg/flag/${lowerCase(data.company.country?.iso3)}.svg`)} alt="" style={{ height: 24, width: 24 }} />}
            {
              data && <span title={data && data.company && data.company.company_name}>{data.company && data.company.company_name}</span>
            }
          </div>

        </Link> 

        {
          (isPreKYCUser || isEndUser) && data.company && data.company.id != memberCompanyID && (
            <div className="product-favorite-icon">
              <div id={favKey} className={isFav == null ? data.isFavorite ? 'fav' : 'unFav' : isFav  ? 'fav' : 'unFav'} />
              {/* <img
                id={favKey}
                src={isFav == null ? data.isFavorite ? fav : unFav : isFav  ? fav : unFav}
                alt="favorite"
                //onClick={handleFavClick}
              /> */}
            </div>)
        }
        {
          !user && <div className='product-favorite-icon'><img src={unFav} alt='favorite'  
          onClick={() => handlefavoriteClick(data)}
          /> </div>
        }
        

        {
          showContact && <div className="btn-wrape">
            {/* <Link
              className="btn outline"
              to="/"
              title="Contact Suppliers"
            > */}
            <button type="button"
              className="btn outline medium"
              onClick={() => handleQuoteClick(data)}
            >
              Contact Supplier
              <span className="round">
                <i className="sprite"></i>
              </span>
            </button>
            {/* </Link> */}
          </div>
        }

      </div>
    </div>
  )
}

export default ProductCard
